// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fd16325c","453":"17063b1b","455":"157005da","977":"497a2bfc"}[chunkId] + ".chunk.js";
};